import { z, ZodObject, ZodRawShape, ZodString } from 'zod';
import { QuestionType, ValidationConfig } from '../../types';

export function generateQuestionResponseSchema(
  questionType: QuestionType,
  validationConfiguration: ValidationConfig
): ZodObject<ZodRawShape> {
  let valueType: ZodString;

  switch (questionType) {
    case 'date':
      // valueType = getValueTypeForDate(configuration);
      valueType = z.string();
      break;
    case 'text':
      valueType = z.string();
      break;
    default:
      valueType = z.string();
      break;
  }

  const isRequired = validationConfiguration?.isRequired || false;

  return z.object({
    value: isRequired ? valueType : valueType.optional().nullish(),
  });
}
